/**
 * Safely and readably joins a prefix and a path segment into a single href.
 *
 * - Trims any trailing `/` from `prefix` and any leading `/` from `path`
 *   and ensures there's exactly one `/` between them.
 * - If `path` is not provided, returns `#`.
 *
 * @param {string} prefix - Base path/prefix (e.g. `/otel` or `/otel/`).
 * @param {string|null|undefined} [path] - Path segment to append (e.g. `robinson-otelleri` or `/robinson-otelleri`).
 * @returns {string} The combined href (e.g. `/otel/robinson-otelleri`).
 *
 * @example
 * buildHref('/otel', 'robinson-otelleri') // '/otel/robinson-otelleri'
 * buildHref('/otel/', '/robinson-otelleri') // '/otel/robinson-otelleri'
 */
export const buildHref = (prefix: string, path?: string | null): string => {
  const pref = String(prefix || '');
  const p = path ?? '#';

  if (p.startsWith('/')) {
    return pref.endsWith('/') ? pref.slice(0, -1) + p : pref + p;
  }

  return pref.endsWith('/') ? pref + p : `${pref}/${p}`;
};
